import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../store";
import {
  setFileName,
  setUploadSuccess,
} from "../../../../../../store/steps/stepFiveSlice";
import { csvToBase64 } from "../../../../../../utils";
import { apiService } from "../../../../services/apiService";
import { useParams } from "react-router-dom";

const useFileUpload = () => {
  const { assessmentId } = useParams();
  const dispatch = useDispatch();
  const { uploadSuccess, fileName } = useSelector(
    (state: RootState) => state.stepFive
  );
  const [file, setFile] = useState<File | undefined>();
  const [uploading, setUploading] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileUpload = async (file: File) => {
    setUploading(true);
    try {
      const base64Data = await csvToBase64(file);
      const filePayload = {
        type: file.type,
        id: crypto.randomUUID(),
        data: base64Data,
        meta: {
          relativePath: file.name,
          name: file.name,
          type: file.type,
        },
      };
      await apiService.uploadCSV({
        id: assessmentId as string,
        csvFile: filePayload,
      });
      dispatch(setFileName(file.name));
      dispatch(setUploadSuccess(true));
      setUploading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement & {
      files: FileList;
    };
    setFile(target.files[0]);
    dispatch(setFileName(target.files[0].name));
    dispatch(setUploadSuccess(false));
  };

  const handleUploadClick = () => {
    if (!file) {
      fileInputRef.current?.click();
    } else {
      fileUpload(file);
    }
  };
  return {
    file,
    fileName,
    uploadSuccess,
    uploading,
    fileInputRef,
    handleFileChange,
    handleUploadClick,
  };
};

export default useFileUpload;
